import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-empty-plan',
  templateUrl: './empty-plan.component.html',
  styleUrl: './empty-plan.component.scss'
})
export class EmptyPlanComponent {
 @Input('secHt') secHt: number;
 @Input('avlblWidth') avlblWidth: number;
 @Input('title') title: string;
 @Input('description') description: string;
 @Input('icon') icon: string;
 @Input('selMonthName') selMonthName: string = '';

}
